<div class="wrapper" [dir]="this.lang.getPageDirection()">
<div class="m-box">
    <h2>{{'appointments.sms-tracking.dialog.title' | translate}}</h2>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="section">
      <div class="section-title">
        <mat-icon>person</mat-icon>
        {{'appointments.gui.labels.patient' | translate}}
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.gui.labels.Patient Name' | translate}}</span>
        <span class="value">{{ data.patientName }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.sms-tracking.dialog.label.sent-time' | translate}}</span>
        <span class="value">{{ data.smsSentTime }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.gui.labels.status' | translate}}</span>
        <span class="value"
              [class.success]="data.status === 'SMS will be sent'"
              [class.error]="data.status !== 'SMS will be sent'">
          {{ data.status === 'SMS will be sent' ? ('appointments.sms-tracking.status.sent' | translate) : data.status }}
        </span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.gui.labels.Date' | translate}}</span>
        <span class="value">{{ data.appointmentTime }}</span>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <mat-icon>link</mat-icon>
        {{'appointments.sms-tracking.dialog.section.link' | translate}}
      </div>
      <div class="link-container">
        <input readonly [value]="data.confirmationLink" class="link-input" dir="ltr">
        <button class="copy-btn" (click)="copyToClipboard(data.confirmationLink)" [matTooltip]="'appointments.sms-tracking.dialog.tooltip.copy' | translate">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <mat-icon>message</mat-icon>
        {{'appointments.gui.labels.message' | translate}}
      </div>
      <div class="message-container">
        <pre class="message-text">{{ data.fullMessage }}</pre>
        <button class="copy-btn-sm" (click)="copyToClipboard(data.fullMessage)" [matTooltip]="'appointments.sms-tracking.dialog.tooltip.copy-msg' | translate">
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <mat-icon>check_circle</mat-icon>
        {{'appointments.gui.labels.Arrival Confirmed' | translate}}
      </div>
      <div class="info-row">
        <span class="value">{{ data.arrivalInfo }}</span>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <mat-icon>history</mat-icon>
        {{'appointments.gui.labels.Changes' | translate}}
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.sms-tracking.dialog.label.deleted' | translate}}</span>
        <span class="value" [class.deleted]="data.wasDeleted">{{ data.wasDeleted ? ('appointments.gui.buttons.Yes' | translate) : ('appointments.gui.buttons.No' | translate) }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.sms-tracking.dialog.label.date-changed' | translate}}</span>
        <span class="value" [class.changed]="data.dateChanged">{{ data.dateChanged ? ('appointments.gui.buttons.Yes' | translate) : ('appointments.gui.buttons.No' | translate) }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.sms-tracking.dialog.label.user-changes' | translate}}</span>
        <span class="value">{{ data.totalUserChanges }}</span>
      </div>
      <div class="info-row">
        <span class="label">{{'appointments.sms-tracking.dialog.label.patient-changes' | translate}}</span>
        <span class="value">{{ data.totalPatientChanges }}</span>
      </div>
    </div>
  </div>

  <div class="dialog-actions">
    <button class="btn-close" (click)="close()">{{'appointments.gui.buttons.Close' | translate}}</button>
  </div>
</div>
